import userIcon from '../icons/img_avatar1.png';
import { v4 as uuidv4 } from 'uuid';

export const data = {
	classes: [
		{
			id: uuidv4(),
			createdDate: '10.04.2002',
			room: '101',
			class: '8"B"',
			teacher: {
				id: uuidv4(),
				firstName: 'Ilhomjon',
				lastName: 'Xomidov',
				teacherImage: userIcon,
			},
			sciences: [
				{
					name: 'Ona titli',
					id: uuidv4(),
				},
				{
					name: 'Adabiyot',
					id: uuidv4(),
				},
				{
					name: 'Fizika',
					id: uuidv4(),
				},
				{
					name: 'Kimyo',
					id: uuidv4(),
				},
				{
					name: 'Ma`naviyat asoslari',
					id: uuidv4(),
				},
				{
					name: 'Matematika',
					id: uuidv4(),
				},
				{
					name: 'Geografiya',
					id: uuidv4(),
				},
				{
					name: 'Rus tili',
					id: uuidv4(),
				},
			],
			students: [
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Zoir',
					lastName: 'Tursunov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Abduqodir ',
					lastName: 'Eshmatov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '550000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shaxboz',
					lastName: 'Solijonov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '900000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Axror',
					lastName: 'Axmadjanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '300000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shuxrat',
					lastName: 'Kenjabayev',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Azizbek',
					lastName: 'Komiljanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
			],
			group: '1',
		},
		{
			id: uuidv4(),
			createdDate: '10.04.2002',
			room: '101',
			class: '8"A"',
			teacher: {
				id: uuidv4(),
				firstName: 'Sherzod',
				lastName: 'Azimov',
				teacherImage: userIcon,
			},
			sciences: [
				{
					name: 'Ona titli',
					id: uuidv4(),
				},
				{
					name: 'Adabiyot',
					id: uuidv4(),
				},
				{
					name: 'Fizika',
					id: uuidv4(),
				},
				{
					name: 'Kimyo',
					id: uuidv4(),
				},
				{
					name: 'Ma`naviyat asoslari',
					id: uuidv4(),
				},
				{
					name: 'Matematika',
					id: uuidv4(),
				},
				{
					name: 'Geografiya',
					id: uuidv4(),
				},
				{
					name: 'Rus tili',
					id: uuidv4(),
				},
			],
			students: [
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Zoir',
					lastName: 'Tursunov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Abduqodir ',
					lastName: 'Eshmatov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '550000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shaxboz',
					lastName: 'Solijonov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '900000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Axror',
					lastName: 'Axmadjanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '300000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shuxrat',
					lastName: 'Kenjabayev',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Azizbek',
					lastName: 'Komiljanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
			],
			group: '1',
		},
		{
			id: uuidv4(),
			createdDate: '10.04.2002',
			room: '101',
			class: '9"G"',
			teacher: {
				id: uuidv4(),
				firstName: 'Izzatilla',
				lastName: 'Bazarov',
				teacherImage: userIcon,
			},
			sciences: [
				{
					name: 'Ona titli',
					id: uuidv4(),
				},
				{
					name: 'Adabiyot',
					id: uuidv4(),
				},
				{
					name: 'Fizika',
					id: uuidv4(),
				},
				{
					name: 'Kimyo',
					id: uuidv4(),
				},
				{
					name: 'Ma`naviyat asoslari',
					id: uuidv4(),
				},
				{
					name: 'Matematika',
					id: uuidv4(),
				},
				{
					name: 'Geografiya',
					id: uuidv4(),
				},
				{
					name: 'Rus tili',
					id: uuidv4(),
				},
			],
			students: [
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Zoir',
					lastName: 'Tursunov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Abduqodir ',
					lastName: 'Eshmatov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '550000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shaxboz',
					lastName: 'Solijonov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '900000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Axror',
					lastName: 'Axmadjanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '300000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shuxrat',
					lastName: 'Kenjabayev',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Azizbek',
					lastName: 'Komiljanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
			],
			group: '1',
		},
		{
			id: uuidv4(),
			createdDate: '10.04.2002',
			room: '101',
			class: '9"V"',
			teacher: {
				id: uuidv4(),
				firstName: 'Rustam',
				lastName: 'Jorayev',
				teacherImage: userIcon,
			},
			sciences: [
				{
					name: 'Ona titli',
					id: uuidv4(),
				},
				{
					name: 'Adabiyot',
					id: uuidv4(),
				},
				{
					name: 'Fizika',
					id: uuidv4(),
				},
				{
					name: 'Kimyo',
					id: uuidv4(),
				},
				{
					name: 'Ma`naviyat asoslari',
					id: uuidv4(),
				},
				{
					name: 'Matematika',
					id: uuidv4(),
				},
				{
					name: 'Geografiya',
					id: uuidv4(),
				},
				{
					name: 'Rus tili',
					id: uuidv4(),
				},
			],
			students: [
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Zoir',
					lastName: 'Tursunov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Abduqodir ',
					lastName: 'Eshmatov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '550000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shaxboz',
					lastName: 'Solijonov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '900000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Axror',
					lastName: 'Axmadjanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '300000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shuxrat',
					lastName: 'Kenjabayev',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Azizbek',
					lastName: 'Komiljanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
			],
			group: '1',
		},
		{
			id: uuidv4(),
			createdDate: '10.04.2002',
			room: '101',
			class: '9"B"',
			teacher: {
				id: uuidv4(),
				firstName: 'Nodir',
				lastName: 'Kamalov',
				teacherImage: userIcon,
			},
			sciences: [
				{
					name: 'Ona titli',
					id: uuidv4(),
				},
				{
					name: 'Adabiyot',
					id: uuidv4(),
				},
				{
					name: 'Fizika',
					id: uuidv4(),
				},
				{
					name: 'Kimyo',
					id: uuidv4(),
				},
				{
					name: 'Ma`naviyat asoslari',
					id: uuidv4(),
				},
				{
					name: 'Matematika',
					id: uuidv4(),
				},
				{
					name: 'Geografiya',
					id: uuidv4(),
				},
				{
					name: 'Rus tili',
					id: uuidv4(),
				},
			],
			students: [
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Zoir',
					lastName: 'Tursunov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Abduqodir ',
					lastName: 'Eshmatov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '550000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shaxboz',
					lastName: 'Solijonov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '900000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Axror',
					lastName: 'Axmadjanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '300000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shuxrat',
					lastName: 'Kenjabayev',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Azizbek',
					lastName: 'Komiljanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
			],
			group: '1',
		},
		{
			id: uuidv4(),
			createdDate: '10.04.2002',
			room: '101',
			class: '9"A"',
			teacher: {
				id: uuidv4(),
				firstName: 'Abror',
				lastName: 'Azimov',
				teacherImage: userIcon,
			},
			sciences: [
				{
					name: 'Ona titli',
					id: uuidv4(),
				},
				{
					name: 'Adabiyot',
					id: uuidv4(),
				},
				{
					name: 'Fizika',
					id: uuidv4(),
				},
				{
					name: 'Kimyo',
					id: uuidv4(),
				},
				{
					name: 'Ma`naviyat asoslari',
					id: uuidv4(),
				},
				{
					name: 'Matematika',
					id: uuidv4(),
				},
				{
					name: 'Geografiya',
					id: uuidv4(),
				},
				{
					name: 'Rus tili',
					id: uuidv4(),
				},
			],
			students: [
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Zoir',
					lastName: 'Tursunov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Abduqodir ',
					lastName: 'Eshmatov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '550000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shaxboz',
					lastName: 'Solijonov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '900000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Axror',
					lastName: 'Axmadjanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '300000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Shuxrat',
					lastName: 'Kenjabayev',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
				{
					id: uuidv4(),
					userName: 'zoir_s',
					firstName: 'Azizbek',
					lastName: 'Komiljanov',
					dateOfBirth: '01.02.2005',
					image: userIcon,
					phoneNumber: '+998991234567',
					location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
					tuitionAmount: '1200000',
					balanse: '-450000',
					studentGrants: '5',
					email: 'info@mail.ru',
					about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
					(born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
					football (soccer) forward who was one of the greatest players of his 
					generation. Ronaldo's father, José Dinis Aveiro, was the`,
				},
			],
			group: '1',
		},
	],
	teachers: [
		{
			id: uuidv4(),
			firstName: 'Abror',
			lastName: 'Azimov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Ilhomjon',
			lastName: 'Xomidov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Sherzod',
			lastName: 'Azimov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Rustam',
			lastName: 'Jorayev',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Izzatilla',
			lastName: 'Bazarov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Nodir',
			lastName: 'Kamalov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Ilhomjon',
			lastName: 'Xomidov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Ahror',
			lastName: 'Azimov',
			teacherImage: userIcon,
		},
		{
			id: uuidv4(),
			firstName: 'Azizbek',
			lastName: 'Azimov',
			teacherImage: userIcon,
		},
	],
	students: [
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Zoir',
			lastName: 'Tursunov',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '-450000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Abduqodir ',
			lastName: 'Eshmatov',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '550000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Shaxboz',
			lastName: 'Solijonov',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '900000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Mirabbos',
			lastName: 'Xamraliyev',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '274000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Axror',
			lastName: 'Axmadjanov',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '300000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Shuxrat',
			lastName: 'Kenjabayev',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '-450000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Azizbek',
			lastName: 'Komiljanov',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '-450000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Ibrohim',
			lastName: 'Tolaboyev',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '-450000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Ulugbek',
			lastName: 'Boqijanov',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '-100000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
		{
			id: uuidv4(),
			userName: 'zoir_s',
			firstName: 'Behzod',
			lastName: 'Umarhojayev',
			dateOfBirth: '01.02.2005',
			image: userIcon,
			phoneNumber: '+998991234567',
			location: 'Toshkent sh. Chilonzor t. Muqumiy 18A uy',
			tuitionAmount: '1200000',
			balanse: '-450000',
			studentGrants: '5',
			email: 'info@mail.ru',
			about: `Cristiano Ronaldo, in full Cristiano Ronaldo dos Santos Aveiro 
      (born February 5, 1985, Funchal, Madeira, Portugal), Portuguese 
      football (soccer) forward who was one of the greatest players of his 
      generation. Ronaldo's father, José Dinis Aveiro, was the`,
		},
	],
	sciences: [
		{
			name: 'Ona titli',
			id: uuidv4(),
		},
		{
			name: 'Adabiyot',
			id: uuidv4(),
		},
		{
			name: 'Fizika',
			id: uuidv4(),
		},
		{
			name: 'Iqtisodiyot',
			id: uuidv4(),
		},
		{
			name: 'Kimyo',
			id: uuidv4(),
		},
		{
			name: 'Ma`naviyat asoslari',
			id: uuidv4(),
		},
		{
			name: 'Matematika',
			id: uuidv4(),
		},
		{
			name: 'Geografiya',
			id: uuidv4(),
		},
		{
			name: 'Rus tili',
			id: uuidv4(),
		},
	],
};
